import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import { Registration } from '../../interfaces';
import { MultiSelectElement } from '../../models/multi-select-element';

@Component({
  selector: 'app-form-question',
  templateUrl: './form-question.component.html',
  styleUrls: ['./form-question.component.less']
})
export class FormQuestionComponent {
  @Input() public question: Registration.Form.IElement;
  @Input() public formGroup: FormGroup;
  @Input() public form: NgForm;
  @Output() public copyAddress = new EventEmitter<Registration.Form.ICopyItem>();

  public get valid(): boolean {
    return this.formGroup.controls[this.question.inputKey].valid;
  }

  public get submitted(): boolean {
    return this.form.submitted;
  }

  public get required(): boolean {
    const attr = this.getAttribute('required');
    return attr && attr === 'required';
  }

  public get placeholder(): string {
    const attr = this.getAttribute('placeholder');
    return attr || '';
  }

  public get pattern(): string {
    const attr = this.getAttribute('pattern');
    return attr || '';
  }

  private getAttribute(name: string): string {
    let result;
    this.question.attributes.forEach((item) => {
      if (item.name === name) {
        result = item.value;
      }
    });

    return result;
  }

  public setMultiselect(): void {
    if (this.question.inputType === 'multiselect') {
      const q = <MultiSelectElement>this.question;
      q.value = '1';
    }
  }

  public onCheckboxClick(): void {
    const copyAddress = this.getAttribute('copyAddress');
    if (copyAddress) {
      const value: Registration.Form.ICopyItem = {
        on: this.question.value,
        values: JSON.parse(copyAddress)
      };

      this.copyAddress.emit(value);
    }
  }
}
